module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Checkbox.js"));
	}, "Checkbox");
}